import { Popover as MUIPopover, modalClasses, styled } from "@mui/material";
import { editorToolbarName } from "../classes.js";
const Popover = styled(MUIPopover, {
  name: editorToolbarName,
  slot: "Popover",
  overridesResolver: (_props, styles) => styles.popover
})(() => ({
  [`.${modalClasses.backdrop}`]: {
    backgroundColor: "transparent"
  }
}));
export {
  Popover
};
//# sourceMappingURL=Popover.js.map
